import { render } from "./CaseBannerMobile.vue?vue&type=template&id=391a652e&scoped=true"
import script from "./CaseBannerMobile.vue?vue&type=script&lang=js"
export * from "./CaseBannerMobile.vue?vue&type=script&lang=js"

import "./CaseBannerMobile.vue?vue&type=style&index=0&id=391a652e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391a652e"]])

export default __exports__